"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _index = _interopRequireDefault(require("./index"));

var View = function View(_ref, ref) {
  var visibleToggle = _ref.visibleToggle,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? _index["default"] : _ref$Component,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["visibleToggle", "Component"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
    ref: ref,
    type: visible ? 'text' : 'password',
    className: (0, _classnames["default"])('w-full', props.className, {
      'pr-16': visibleToggle
    })
  })), visibleToggle && /*#__PURE__*/_react["default"].createElement("button", {
    tabindex: "-1",
    type: "button",
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      setVisible(!visible);
    },
    className: "absolute right-0 top-0 flex items-center justify-center w-16 h-full text-light text-lg"
  }, visible ? /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
    fontSize: "inherit"
  }) : /*#__PURE__*/_react["default"].createElement(_Visibility["default"], {
    fontSize: "inherit"
  })));
};

View.displayName = 'PasswordInput';

var _default = /*#__PURE__*/(0, _react.forwardRef)(View);

exports["default"] = _default;
//# sourceMappingURL=PasswordInput.js.map